import HistoryTitle from './HistoryTitle';

export default HistoryTitle;
